import React, { useState } from "react";
import { Eye, EyeOff, Lock, User } from "lucide-react";
import { Button } from "../../components/Button";
import { Input } from "../../components/Input";
import { Checkbox } from "../../components/Checkbox";
import { BTBLogo } from "../../components/BTBLogo";
export function AdminLogin({
  onLogin,
  onApplicant
}: {
  onLogin: () => void;
  onApplicant: () => void;
}) {
  const [showPassword, setShowPassword] = useState(false);
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [remember, setRemember] = useState(true);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!userId.trim() || !password.trim()) {
      setError("অনুগ্রহ করে ইউজার আইডি এবং পাসওয়ার্ড লিখুন।");
      return;
    }
    setError("");
    onLogin();
  };
  return <div className="flex min-h-screen flex-col bg-[#F7F9F8]" data-id="element-878" data-mp="dhfac0rdrb5l">
      <div className="flex flex-1 items-center justify-center px-4 py-10" data-id="element-879" data-mp="diqg264dyszc">
        <div className="w-full max-w-md" data-id="element-880" data-mp="2x8js2oftjcsk">
          <div className="mb-6 flex flex-col items-center text-center" data-id="element-881" data-mp="2x9blptpuv0g7">
            <BTBLogo size="lg" className="mb-4 rounded-full bg-white p-1 shadow-sm" data-id="element-882" data-mp="2s9yp4h96mf0f" />
            <p className="text-xs font-medium text-[#667085]" data-id="element-883" data-mp="376fzp69jrplx">গণপ্রজাতন্ত্রী বাংলাদেশ সরকার · বেসামরিক বিমান পরিবহন ও পর্যটন মন্ত্রণালয়</p>
            <h1 className="mt-2 text-2xl font-bold text-[#1F2937]" data-id="element-884" data-mp="328xxrzty6anf">বাংলাদেশ ট্যুরিজম বোর্ড</h1>
            <p className="mt-1 text-sm text-[#667085]" data-id="element-885" data-mp="3g401cgbbnnx2">ইভেন্ট, প্রতিযোগিতা ও আবেদন ব্যবস্থাপনা সিস্টেম</p>
          </div>

          <form onSubmit={handleSubmit} className="rounded-2xl border border-[#D9E2DE] bg-white p-6 shadow-md sm:p-8" data-id="element-886" data-mp="3pvwduwe5ngkt">
            <div className="mb-2 flex h-1 w-full overflow-hidden rounded-full" data-id="element-887" data-mp="3kwt7n8mfv4b9"><span className="w-[85%] bg-[#006A4E]" data-id="element-888" data-mp="2rg55f93liv4" /><span className="w-[15%] bg-[#F42A41]" data-id="element-889" data-mp="2shtglf4k1us" /></div>
            <h2 className="mt-4 mb-5 text-center text-lg font-bold text-[#1F2937]" data-id="element-890" data-mp="3uv8ydahk0bk8">প্রশাসনিক লগইন</h2>

            {error && <div role="alert" className="mb-4 rounded-lg border border-rose-200 bg-rose-50 px-3 py-2 text-sm text-[#C61E35]" data-id="element-891" data-mp="5tb98umu30al">{error}</div>}

            <label className="mb-1.5 block text-sm font-medium text-[#1F2937]" htmlFor="userId" data-id="element-892" data-mp="asxmv56kqijx">ইউজার আইডি / ইমেইল</label>
            <div className="relative mb-4" data-id="element-893" data-mp="fpxo92shax4p">
              <User className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-[#667085]" data-id="element-894" data-mp="kih64by78efb" />
              <Input id="userId" value={userId} onChange={e => setUserId(e.target.value)} placeholder="arif.islam@tourismboard.gov.bd" className="h-11 pl-10" data-id="element-895" data-mp="oiiwvq2ebnft" />
            </div>

            <label className="mb-1.5 block text-sm font-medium text-[#1F2937]" htmlFor="password" data-id="element-896" data-mp="yh737rl0qe3o">পাসওয়ার্ড</label>
            <div className="relative mb-4" data-id="element-897" data-mp="13fs2nosg4tr2">
              <Lock className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-[#667085]" data-id="element-898" data-mp="13eqohbg4vr54" />
              <Input id="password" type={showPassword ? "text" : "password"} value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" className="h-11 pl-10 pr-10" data-id="element-899" data-mp="3586kknuzpy7h" />
              <button type="button" aria-label={showPassword ? "পাসওয়ার্ড আড়াল করুন" : "পাসওয়ার্ড দেখান"} onClick={() => setShowPassword(v => !v)} className="absolute right-3 top-1/2 -translate-y-1/2 text-[#667085]" data-id="element-900" data-mp="1hmd9f94zotdt">
                {showPassword ? <EyeOff className="h-4 w-4" data-id="element-901" data-mp="18mq6giwm3fin" /> : <Eye className="h-4 w-4" data-id="element-902" data-mp="18ni19ridx97v" />}
              </button>
            </div>

            <div className="mb-5 flex items-center justify-between" data-id="element-903" data-mp="25amn1ns1uatv">
              <label className="flex items-center gap-2 text-sm text-[#1F2937]" data-id="element-904" data-mp="21a2teu6oppch">
                <Checkbox checked={remember} onCheckedChange={v => setRemember(Boolean(v))} data-id="element-905" data-mp="1wazmf475991v" />
                আমাকে মনে রাখুন
              </label>
              <button type="button" className="text-sm font-medium text-[#006A4E] hover:underline" data-id="element-906" data-mp="1rbn0qms0e80v">পাসওয়ার্ড ভুলে গেছেন?</button>
            </div>

            <Button type="submit" className="h-11 w-full bg-[#006A4E] text-white hover:bg-[#005A3C]" data-id="element-907" data-mp="fx9hxwc44irp">লগইন করুন</Button>

            <button type="button" onClick={onApplicant} className="mt-4 w-full text-center text-sm font-medium text-[#006A4E] hover:underline" data-id="element-908" data-mp="23tfnkk4bwu0c">আবেদনকারী পোর্টালের হোম পেজে যান</button>
          </form>

          <p className="mt-6 text-center text-xs leading-relaxed text-[#667085]" data-id="element-909" data-mp="1utsmy0jfbs8c">
            বাংলাদেশ ট্যুরিজম বোর্ড<br data-id="element-910" data-mp="1zt5kpgbu2jpp" />বেসামরিক বিমান পরিবহন ও পর্যটন মন্ত্রণালয়<br data-id="element-911" data-mp="1zpq2i4mv4uk2" />গণপ্রজাতন্ত্রী বাংলাদেশ সরকার
          </p>
        </div>
      </div>
    </div>;
}